import React from "react";
import ProductsManagement from "../../features/productsmanagement";

const AssetsProductsManagementPage = () => <ProductsManagement />

export default AssetsProductsManagementPage;